﻿import { PlainTableOutput } from 'ckeditor5';

class CustomPlainTableOutput extends PlainTableOutput {
    static get pluginName() { return "CustomPlainTableOutput" };

    init() {
        super.init();

        // Set default width
        if (this.editor.plugins.has('TableProperties')) {
            this.editor.model.on('insertObject', (eventInfo, args) => {
                if (args && Array.isArray(args) && args.length > 0) {
                    var insertedObject = args[0];

                    if (insertedObject && insertedObject.name === 'table') {
                        this.editor.model.change(writer => {
                            writer.setAttribute('tableRole', 'presentation', insertedObject);
                            writer.setAttribute('tableWidth', '100%', insertedObject);
                        });
                    }
                }
            });
        }
    }
}

export default CustomPlainTableOutput;